import { render } from "./spxdxqMx.vue?vue&type=template&id=4e6178bb&scoped=true"
import script from "./spxdxqMx.vue?vue&type=script&lang=js"
export * from "./spxdxqMx.vue?vue&type=script&lang=js"

import "./spxdxqMx.vue?vue&type=style&index=0&id=4e6178bb&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6178bb"]])

export default __exports__